import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import JI_TITLE from './title';
import MyApp from './App.js'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <JI_TITLE />
    <MyApp />
    {window.location.pathname === '/' && reportWebVitals()}
  </React.StrictMode>
);